import React from 'react';
import { CreditCard, ShieldCheck, Lock } from 'lucide-react';
import './CardAssinatura.css';

const CardAssinatura = ({ plano, email,processarAssinatura }) => {
  return (
    <div className="card-assinatura">
      <div className="card-header">
        <h2 className="titulo-plano">Plano EBD Chamadas</h2>
        <div className="preco-container">
          <span className="preco">R$ {plano.preco}</span>
          <span className="periodo">{plano.nome}</span>
        </div>
      </div>
   
      <button className="btn-assinar" onClick={()=>processarAssinatura()}>
        <Lock size={18} />
        <span>Assinar Agora</span>  
      </button>

      {/* Aviso de Redirecionamento */}
      <p className="aviso-redirecionamento">
        *Você será redirecionado para concluir o pagamento em um ambiente seguro.
      </p>

      <div className="metodos-pagamento">
        <p className="texto-apoio">Formas de pagamento aceitas:</p>
        <div className="icones-pagamento">
          <span className="bandeira">AMEX</span>
          <span className="bandeira">MASTERCARD</span>
          <span className="bandeira">VISA</span>
        </div>
      </div>
    </div>
  );
};

export default CardAssinatura;